import type { FormFieldInstance, FormFieldOption } from '@/form/useForm'
import { tv } from 'tailwind-variants'
import { computed, unref, type MaybeRef } from 'vue'
import { defineComponent } from 'vue'


const variants = tv({
  slots: {
    base: "grid grid-cols-[repeat(auto-fit,minmax(1rem,1fr))] items-center min-h-[42px]",
    item: "cursor-pointer transition-all bg-gray-100 text-gray-500 data-[selected=true]:text-white flex items-center justify-center py-2.5"
  },
  variants: {
    size: {
      sm: {
        item: "text-sm font-medium"
      }
    }
  }
})


export const ButtonGroup = defineComponent<{
  dataRef?: FormFieldInstance<number> | FormFieldInstance<string>;
  value?: number | boolean | string;
  items?: MaybeRef<FormFieldOption[]>;
  size?: "sm"
}>(
  (props) => {
    const optionItems = computed(() => unref(props.items) || props.dataRef?.attributes?.value?.options?.items || [])


    const handleClick = (item: FormFieldOption) => {
      if (props.dataRef) {
        props.dataRef.setValue(item.value);
      }
    };

    const cls = variants({ size: props.size });


    return () => {
      return (
        <div class={cls.base({})}>
          {optionItems.value.map((item) => {
            const selected = item.value === props.value
            return (
              <div
                onClick={() => handleClick(item)}
                data-selected={selected}
                class={[
                  cls.item({}),
                  selected ? "bg-primary-500 border border-primary-400" : "border border-gray-300 hover:bg-primary-100 hover:border-primary-500 hover:text-primary-500 transition-all",
                ]}
              >
                {item.label}
              </div>
            )
          })}
        </div>
      )
    }
  },
  { props: ['dataRef', 'value', 'items', 'size'] }
)
